module.exports = __webpack_public_path__ + "img/account.1089ff11.svg";